import CIMSTable from 'components/CIMSTable'
import { useRolesTableContext } from '../../../../RolesTableContext'
import { useColumns } from './hooks/useColumns'
import { useCreateOptions } from './hooks/useCreateOptions'
import { useEditOptions } from './hooks/useEditOptions'
import { useRemoveOptions } from './hooks/useRemoveOptions'
import { useRestoreOptions } from './hooks/useRestoreOptions'

export const RolesTable: React.FC = () => {
  const { records, refetch, fetching } = useRolesTableContext()

  const columns = useColumns()
  const createOptions = useCreateOptions()
  const editOptions = useEditOptions()
  const removeOptions = useRemoveOptions()
  const restoreOptions = useRestoreOptions()

  return (
    <CIMSTable
      rowKey={'id'}
      records={records}
      loading={fetching}
      columns={columns}
      actions={{
        header: {
          create: createOptions,
          onReload: refetch,
        },
        row: {
          edit: editOptions,
          remove: removeOptions,
          restore: restoreOptions,
        },
      }}
    />
  )
}
